import { StyleSheet } from 'react-native';
import { colors } from '../../shared/theme/colors'
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';
import { ticketColors } from '../../shared/theme/ticketColors';
import { posLayoutStyleDefs } from './posLayout.styleDefs';
import { posCatalogHeaderStyleDefs } from './catalog/posCatalogHeader.styleDefs';
import { posCatalogProductStyleDefs } from './catalog/posCatalogProduct.styleDefs';
import { posCartStyleDefs } from './cart/posCart.styleDefs';
import { posCheckoutStyleDefs } from './checkout/posCheckout.styleDefs';

// TS 6 + RN 0.85: style-def spreads carry readonly fontVariant from ticket tokens.
const posSharedStyleInput = {
  ...posLayoutStyleDefs,
  ...posCatalogHeaderStyleDefs,
  ...posCatalogProductStyleDefs,
  ...posCartStyleDefs,
  ...posCheckoutStyleDefs,
  // Dock y sheet: controles persistentes del POS con borde ink stone Square.
  posMobileCartBar: {
    borderTopWidth: 1,
    borderTopColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    paddingHorizontal: 12,
    paddingVertical: 10,
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    gap: 10,
  },
  posMobileCartSheetPanel: {
    width: '100%' as const,
    maxHeight: '86%' as const,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderTopWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    paddingHorizontal: 16,
    paddingTop: 8,
    overflow: 'hidden' as const,
  },
  diningTableBackdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'center' as const,
    padding: spacing.lg,
  },
  diningTableCard: {
    maxHeight: '80%' as const,
    borderRadius: 16,
    backgroundColor: colors.surface,
    padding: spacing.md,
    gap: spacing.sm,
  },
  diningTableTitle: {
    ...typography.title3,
    color: colors.textPrimary,
  },
  diningTableSubtitle: {
    ...typography.caption,
    color: colors.textSecondary,
  },
  diningTableHint: {
    ...typography.body,
    color: colors.textSecondary,
    paddingVertical: spacing.md,
  },
  diningTableList: {
    width: '100%',
    maxHeight: 320,
    paddingVertical: spacing.xs,
    gap: spacing.xs,
  },
  diningTableRow: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    justifyContent: 'space-between' as const,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.surface,
    gap: spacing.sm,
  },
  diningTableRowText: {
    ...typography.body,
    color: colors.textPrimary,
    fontWeight: '600' as const,
    flexShrink: 1,
  },
  diningTableRowMeta: {
    ...typography.caption,
    color: colors.textSecondary,
    textAlign: 'right' as const,
  },
  diningTableRowDisabled: {
    opacity: 0.45,
  },
  diningTableRowMetaOccupied: {
    ...typography.caption,
    color: colors.danger,
    textAlign: 'right' as const,
  },
  diningTableCancel: {
    alignItems: 'center' as const,
    paddingVertical: spacing.sm,
  },
  diningTableCancelText: {
    ...typography.body,
    color: colors.textSecondary,
    fontWeight: '600' as const,
  },
};

export const styles = StyleSheet.create(posSharedStyleInput as any);
